export class VehicleSeverity {
  id: number = -1;
  severity: number = -1
  isVor:boolean = false;
  notes: string = '';
  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
